export const optionUseQuery: any = {
  refetchOnWindowFocus: false,
  retry: 0,
};

